export const textColors = {
  base: {
    color: '$base'
  },
  text1: {
    color: '$text1'
  },
  text2: {
    color: '$text2'
  },
  text3: {
    color: '$text3'
  },
  text4: {
    color: '$text4'
  },
  textAccent: {
    color: '$textAccent'
  },
  textSecondary: {
    color: '$textSecondary'
  },
  textError: {
    color: '$textError'
  },
  textWarning: {
    color: '$textWarning'
  },

  accent: {
    color: '$accent'
  },
  accentHover: {
    color: '$accentHover'
  },
  secondary: {
    color: '$secondary'
  },
  secondaryHover: {
    color: '$secondaryHover'
  },
  error: {
    color: '$error'
  },
  errorHover: {
    color: '$errorHover'
  },
  success: {
    color: '$success'
  },
  successHover: {
    color: '$successHover'
  },
  warning: {
    color: '$warning'
  },
  warningHover: {
    color: '$warningHover'
  },

  transparent: {
    color: '$transparent'
  },

  gradient: {
    color: '$transparent',
    backgroundClip: 'text',
    backgroundImage: '$colors$gradient'
  },

  textReversed: {
    color: '$textReversed'
  }
}
